// extracted by mini-css-extract-plugin
export default {"svgIcon":"icon_svgIcon__9+6ub","svgIconInner":"icon_svgIconInner__9u-vE","rotate":"icon_rotate__ZPCie"};